module.exports = __webpack_public_path__ + "img/avbi01a.2913dd50.png";